import React from "react";
import { OverlayTrigger, Spinner, Tooltip } from "react-bootstrap";
import { customColorMapping } from "../../custom-tables/constants";
import "../display.css";

const loadingKeys = {
  proccessing: true,
  "in progress": true,
  submitted: true,
  "in queue": true,
  sending: true
};

export default function StatusDisplay(props) {
  const keyName = customColorMapping[props.data ? props.data.toLowerCase() : props.data];

  if (!props.data) return <></>;
  return (
    <OverlayTrigger placement="bottom" overlay={<Tooltip>{props.data}</Tooltip>} trigger={["hover", "focus"]}>
      <span
        className={`data-container ${!loadingKeys[props.data.toLowerCase()] ? `badge badge-dark bg-${keyName}` : `badge badge-dark bg-${keyName}`}`}
        style={{
          maxWidth: "250px",
          overflow: "hidden",
          textOverflow: "ellipsis",
        }}
      >
        {loadingKeys[props.data.toLowerCase()] && <Spinner animation="border" variant="light" style={{ width: "16px", height: "16px", marginRight: "10px" }}></Spinner>}
        {props.data}
      </span>
    </OverlayTrigger>
  );
}
